"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deepClone_1 = require("./deepClone");
var assign = function (target, src) {
    var objAssign = Object.assign;
    return typeof objAssign === 'function'
        ? objAssign(target, src)
        : (0, deepClone_1.default)(target, src, true);
};
exports.default = assign;
//# sourceMappingURL=assign.js.map